// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2ez3_","title":"ClientReferral_title__1FdLc","itemText":"ClientReferral_itemText__3zhuo"};